import { render, staticRenderFns } from "./Sidenav.vue?vue&type=template&id=752c7b08&scoped=true"
import script from "./Sidenav.vue?vue&type=script&lang=js"
export * from "./Sidenav.vue?vue&type=script&lang=js"
import style0 from "./Sidenav.vue?vue&type=style&index=0&id=752c7b08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752c7b08",
  null
  
)

export default component.exports